<template>
  <card dis-hover :padding="12" class="contracts-item" @click.native="goToContract">
    <div class="contracts-item__index">
      <span class="ms-help">{{ index }}.</span>
    </div>
    <div class="contracts-item__left">
      <div class="contracts-item__main-info">
        <tag class="status" :color="getContractStatusColor(contract.status)">
          {{ contract.status }}
        </tag>
        <div class="contracts-item__name ms-subhead">
          <!-- {{ contract.code }}. {{ contract.name }} -->
          <ellipsis-text :max-width="460" :text="`${contract.code}. ${contract.name}`" />
          <div class="contracts-item__number ms-help">
            №{{ contract.number }} от {{ contract.sign_date }}
          </div>
        </div>
      </div>
      <div class="contracts-item__companies">
        <div class="contracts-item__company customer">
          <span class="ms-text">Заказчик:</span>
          <span class="ms-small-head">{{ contract.customer }}</span>
        </div>
        <div class="contracts-item__company performer">
          <span class="ms-text">Исполнитель:</span>
          <span class="ms-small-head">{{ contract.performer }}</span>
        </div>
      </div>
    </div>
    <div class="contracts-item__center">
      <div class="contracts-item__dates">
        <div class="contracts-item__date start">
          <span class="ms-help">Начало: {{ formatDefaultDate(contract.start_date) }}</span>
        </div>
        <div class="contracts-item__date end">
          <span class="ms-help">Окончание: {{ formatDefaultDate(contract.end_date) }}</span>
        </div>
      </div>
      <div class="contracts-item__stats">
        <contract-progress
          label="Акты"
          :part="contract.act_value"
          :all="contract.costs"
        />
        <contract-progress
          label="Платежи"
          :part="contract.already_payed"
          :all="contract.costs"
        />
      </div>
    </div>
    <div class="contracts-item__right">
      <div class="contracts-item__status">
        <tag class="ms-costs" color="primary">
          {{ getFormattedCosts(contract.costs, false, contract.with_vat) }}
        </tag>
      </div>
      <div class="contracts-item__job-types">
        <collapsed-job-types :job-types="contract.job_types" />
      </div>
    </div>
  </card>
</template>

<script>
import ContractProgress from '@/components/contract/info/contract-progress'
import EllipsisText from '@/components/parts/ellipsis-text'
import CollapsedJobTypes from '@/components/parts/collapsed-job-types'
import { getContractStatusColor, getFormattedCosts, formatDefaultDate } from '@/utils'

export default {
  props: ['contract', 'index'],
  components: {
    ContractProgress,
    EllipsisText,
    CollapsedJobTypes
  },
  methods: {
    goToContract () {
      this.$store.commit('SET_COME_FROM', null)

      const route = this.$router.resolve({ path: `/app/contracts/${this.contract.id}/overview` })

      window.open(route.href, '_blank')
    },
    getContractStatusColor,
    getFormattedCosts,
    formatDefaultDate
  }
}
</script>

<style lang="less">
.contracts-item {
  margin-bottom: 16px;
  box-sizing: border-box;
  cursor: pointer;

  &:hover {
    border-color: rgba(@primary-color, 0.6) !important;
  }

  .ivu-card-body {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    box-sizing: border-box;

    a {
      display: flex;
      align-items: center;

      .contracts-item__name {
        margin-left: 8px;
      }
    }
  }

  &__index {
    margin-right: 8px;
  }

  &__left {
    width: 50%;
    flex-shrink: 0;
    box-sizing: border-box;
  }
  &__center {
    width: 22%;
    flex-shrink: 0;
    margin: 0 32px;
    box-sizing: border-box;
  }
  &__right {
    flex-shrink: 0;
    flex: 1;
    box-sizing: border-box;
  }

  &__main-info {
    display: flex;
    width: 100%;

    .ivu-tag {
      flex-shrink: 0;
      width: 112px !important;
      min-width: 96px;
      height: 40px;
      line-height: 40px;
      margin: 0;
    }
  }

  &__name {
    margin-left: 12px;
    width: 460px;
  }

  &__number {
    font-weight: normal;
    margin-top: 2px;
  }

  &__companies {
    display: flex;
    margin-top: 8px;
    display: flex;
  }

  &__company {
    display: flex;
    align-items: center;

    .ms-text {
      margin-right: 4px;
    }

    .ms-small-head {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 160px;
    }

    &.performer {
      margin-left: 16px;
    }
  }

  &__job-types {
    text-align: right;
    margin-top: 4px;

    .ivu-tag {
      margin-right: 0;
      margin-left: 4px;
    }
  }

  &__status {
    margin-left: 8px;
    flex-shrink: 0;
    text-align: right;

    .ivu-tag {
      margin-right: 0;
      width: 200px;
      text-align: center;
    }
  }

  &__dates {
    display: flex;

    .ms-help {
      font-size: 11px;
    }

    .end {
      margin-left: 16px;
    }
  }
}
</style>
